module.exports = __webpack_public_path__ + "img/between.be5030ca.webp";